import styles from "./PolicyError.module.css";

interface PolicyErrorProps {
  error: string;
}

export default function PolicyError({ error }: PolicyErrorProps): JSX.Element {
  return (
    <div className={styles.container}>
      <div className={styles.text}>{error}</div>
    </div>
  );
}
